import { render } from "./LotFileuploadComm.vue?vue&type=template&id=18963b7e&scoped=true"
import script from "./LotFileuploadComm.vue?vue&type=script&lang=js"
export * from "./LotFileuploadComm.vue?vue&type=script&lang=js"

import "./LotFileuploadComm.vue?vue&type=style&index=0&id=18963b7e&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18963b7e"]])

export default __exports__